'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
require('../node_modules/prop-types/index.js');
var clsx_m = require('../node_modules/clsx/dist/clsx.m.js');
var ButtonBase = require('@material-ui/core/ButtonBase');
var AscIcon = require('@material-ui/icons/KeyboardArrowDownRounded');
var DescIcon = require('@material-ui/icons/KeyboardArrowUpRounded');
var useDataTable = require('./useDataTable.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var ButtonBase__default = /*#__PURE__*/_interopDefaultLegacy(ButtonBase);
var AscIcon__default = /*#__PURE__*/_interopDefaultLegacy(AscIcon);
var DescIcon__default = /*#__PURE__*/_interopDefaultLegacy(DescIcon);

var HeaderCell = _ref => {
  var {
    index,
    column
  } = _ref;
  var {
    isResizing,
    startResizing,
    columns,
    sortBy = '',
    setSortBy
  } = useDataTable.useDataTable();
  var {
    dataKey,
    width = 0,
    align = 'left',
    title = '',
    isSortable = false,
    hasSubtotals
  } = columns[index];
  var SortIcon = sortBy.startsWith('-') ? DescIcon__default['default'] : AscIcon__default['default'];
  var clickProps = {};
  var isClickable = isSortable || hasSubtotals;
  var isSelected = sortBy.startsWith('-') ? sortBy.slice(1) === dataKey : sortBy === dataKey;

  if (isSortable) {
    clickProps.onClick = () => isSelected ? setSortBy(sortBy.startsWith('-') ? dataKey : "-".concat(dataKey)) : setSortBy(dataKey);
  }

  return /*#__PURE__*/React__namespace.createElement("div", _rollupPluginBabelHelpers['extends']({
    role: "button",
    tabIndex: 0,
    className: clsx_m("GenjoDataTable__cell", "GenjoDataTable__header-cell", {
      "is-selected": isSelected
    }),
    style: {
      width: width,
      maxWidth: width,
      minWidth: width,
      pointerEvents: isResizing ? 'none' : 'unset',
      cursor: isClickable ? 'pointer' : 'unset'
    }
  }, clickProps), /*#__PURE__*/React__namespace.createElement("div", {
    className: "GenjoDataTable__title-container",
    style: {
      justifyContent: column.align === 'left' ? 'flex-start' : column.align === 'right' ? 'flex-end' : 'center',
      width: width - 16
    }
  }, /*#__PURE__*/React__namespace.createElement("span", {
    className: "GenjoDataTable__title"
  }, column.title), isSortable && Boolean(SortIcon) && /*#__PURE__*/React__namespace.createElement(SortIcon, {
    className: "GenjoDataTable__sort-icon"
  })), /*#__PURE__*/React__namespace.createElement(ButtonBase__default['default'], {
    onMouseDown: event => startResizing(event, index),
    className: "GenjoDataTable__resize-handle"
  }));
};
HeaderCell.propTypes = {};

exports.HeaderCell = HeaderCell;
